import { render, staticRenderFns } from "./lista-listado.vue?vue&type=template&id=b94bc6c2&"
import script from "./lista-listado.vue?vue&type=script&lang=ts&"
export * from "./lista-listado.vue?vue&type=script&lang=ts&"
import style0 from "./lista-listado.vue?vue&type=style&index=0&id=b94bc6c2&prod&lang=css&"
import style1 from "./lista-listado.vue?vue&type=style&index=1&id=b94bc6c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports